<template>
  <div class="extension" ref="imageWrapper">
    <img class="goback" @click="goback" src="../../static/images/fanhui.png"/>
    <img class="tabletops" src="../../static/images/extension/logo3.png" alt="">
    <div class="content">
      <img class="qrcode" :src="qrcode">
      <p class="website">网站查询: WWW.ZHSTNY.CN</p>
      <div class="sucode">
        <span>溯 源 码 :</span>
        <span>{{ suyuanCode }}</span>
      </div>
    </div>
    <div class="boot">
        <div class="boottop">溯源商品</div>
      <div class="bootb">
          <img class="bootleft" :src="ProductPhoto">
          <div class="bootright">
            <p class="bootrt">{{ Tradename }}</p>
            <p class="bootrb">作业智能化、办公智能化、销售区块链溯源可视化</p>
          </div>
      </div>
    </div>
<!--    <div class="abcf"></div>-->
    <p class="screenshots" @click="toImage">生成海报</p>
    <van-popup  v-model="show"><img :src="imgUrl"></van-popup>
  </div>
</template>
<script>
  import Vue from 'vue'
  import html2canvas from "html2canvas";
  import { Popup } from 'vant';

  Vue.use(Popup);
  Vue.use(html2canvas);
export default {
  data() {
    return{
        goods_id: 0,//产品id
        suyuanCode: '',//溯源码
        Tradename: '',//产品名
        ProductPhoto: '', //产品图片
        qrcode: '',//二维码
        imgUrl: '',//页面截图
        show: false,
    };
  },
  created() {
    this.goods_id = this.$route.query.goods_id || '';
    if(this.goods_id == '')this.$route.push('/');
  },
  mounted() {
    //判断是否登陆
    if (!window.localStorage.getItem( 'is_check_login') || window.localStorage.getItem( 'is_check_login') == 0){
      this.$router.push('/login');
    }else{
      this.appextension()
    }
  },
  methods: {
    async appextension(){
      this.$request.post( '/front/Goods/ginfo',{ goods_id: this.goods_id },res => {
        console.log(res);
        if(res.status == 1) {
          console.log(res)
           this.Tradename = res.result.goods_name;
           this.suyuanCode = res.result.sign.sign_number;
           this.ProductPhoto = res.result.goods_mainshow;
           this.qrcode = res.result.sign.sign_qrcode;
        }
      })
    },

    toImage(){
      html2canvas(this.$refs.imageWrapper).then(canvas => {
        let dataURL = canvas.toDataURL("image/png");
        this.imgUrl = dataURL;
        if (this.imgUrl !== "") {
          this.showPopup()
        }
      });
    },
    showPopup() {
      this.show = true;
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.tabletops{
  margin-top:0.38rem;
  width: 5.54rem;
  margin-left: 1.22rem;
  margin-right: 1.22rem;
  }
.content{
  margin-top: 2.15rem;
  width: 4.4rem;
  height: 4.4rem;
  margin: 0 auto;
  padding-top: 0.80rem;
  background-image: url("../../static/images/extension/tc.png");
  background-size: contain;
  font-size: 0.12rem;
  color: #000000;
  margin-top: 0.26rem;
}
.website{
  font-size: 0.18rem;
  margin-left: 0.8rem;
}
.sucode{
  font-size: 0.18rem;
  margin-left: 0.8rem;
}
.qrcode{
  margin-top: 0.25rem;
  width: 2.7rem;
  height: 2.7rem;
  margin-left: 0.89rem;
  margin-bottom: 0.1rem;
}
.boot{
  width: 6.3rem;
  height: 4.73rem;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 0.15rem;
  margin: 0 auto;
  margin-top: 0.41rem;
  padding-top: 0.3rem;
}
.abcf{
  height: 3rem;
  width: 100%;
}
.boottop{
  width: 2.65rem;
  height: 0.67rem;
  font-size: 0.42rem;
  background-color: rgba(0, 120, 213, 1);
  border-radius: 33.5px;
  color: #ffffff;
  text-align: center;
  line-height: 0.67rem;
  margin: 0 auto;
}
.bootb{
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;
}
.bootleft{
  height: 1.98rem;
  width: 1.98rem;
  border-radius: 0.4rem;
  margin-left: 0.42rem;
}
.active{
  display: none;
}
.bootright{
  margin-left: 0.84rem;
  margin-right: 0.48rem;
}
.bootrb{
  font-size: 0.3rem;
  color: rgb(0,1,0);
}
.bootrt{
  font-size: 0.36rem;
  color: rgb(1,96,169);
  margin-bottom: 0.2rem;
}
.screenshots{
  height: 0.4rem;
  width: 1.5rem;
  background-color: #5ec4ff;
  border-radius: 0.2rem;
  margin-left: 5.4rem;
  color: #ffffff;
  line-height: 0.4rem;
  text-align: center;
  font-size: 0.28rem;
  margin-top: 0.5rem;

}
.extension{
  height: 100%;
  background-image: url('../../static/images/ba.png');
  background-size: 100% 100%;
}
.goback{
  width: 0.3rem;
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/extension.vue